import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function SportsInjury() {
  useEffect(() => {
    document.title = "Sports Injury Management | Viksha Health Care";
    const newMetaDescription =
      "Sports injury management at Viksha Health Care. Diagnosis, pain control, rehabilitation planning, and safe return to activity.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Sports Injury Management</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Sports-Injury-Management.avif" />
        </div>
        <div className="textareaofser">
          <h1>Sports Injury Management</h1>

          <p>
            Sports injuries can affect muscles, ligaments, tendons, bones, and
            joints. Proper evaluation and timely management help reduce pain,
            speed up recovery, and prevent long-term complications. Whether you
            are a professional athlete or a fitness enthusiast, the goal is to
            help you return to activity safely.
          </p>

          <p>
            Injuries may occur suddenly during sports or develop gradually due
            to overuse. Early attention can shorten recovery time and reduce the
            risk of repeat injuries.
          </p>

          <h5>Common Sports Injuries We Treat</h5>
          <ul>
            <li>Ligament injuries such as ACL tears and ankle sprains</li>
            <li>Muscle strains and tears</li>
            <li>Tendon injuries like tennis elbow or Achilles tendinitis</li>
            <li>Shoulder injuries in throwing or overhead sports</li>
            <li>Knee injuries from running or jumping activities</li>
            <li>Stress fractures from repetitive impact</li>
          </ul>

          <h5>Initial Evaluation</h5>
          <p>
            A detailed history of how the injury occurred, along with a focused
            physical examination, helps identify the type and severity of the
            injury. Imaging tests may be advised when needed to confirm the
            diagnosis and guide treatment.
          </p>

          <h5>Treatment Approach</h5>

          <h6>Immediate Care</h6>
          <p>
            Early care often includes rest, protection of the injured area, and
            measures to control pain and swelling.
          </p>

          <h6>Non-Surgical Treatment</h6>
          <p>
            Many sports injuries can be managed without surgery. Treatment may
            include medications, physiotherapy, supportive braces, and gradual
            strengthening programs tailored to your sport and activity level.
          </p>

          <h6>Rehabilitation</h6>
          <p>
            Structured rehabilitation plays a key role in recovery. Exercises
            focus on restoring flexibility, strength, balance, and coordination
            to help prevent re-injury and improve performance.
          </p>

          <h6>Surgical Treatment (When Needed)</h6>
          <p>
            In cases of severe ligament tears, fractures, or persistent
            instability, surgical treatment may be recommended to repair damaged
            structures and restore joint function.
          </p>

          <h5>Return-to-Sport Guidance</h5>
          <p>
            Returning to sports too early can increase the risk of re-injury. A
            gradual, supervised return-to-sport plan ensures that strength,
            flexibility, and movement have recovered adequately before resuming
            full activity.
          </p>

          <h5>Injury Prevention Strategies</h5>
          <ul>
            <li>Proper warm-up and stretching before activity</li>
            <li>Strength and conditioning exercises</li>
            <li>Using correct sports techniques and equipment</li>
            <li>Avoiding overtraining and allowing rest days</li>
            <li>Maintaining good flexibility and muscle balance</li>
          </ul>

          <h5>Who Can Benefit from Sports Injury Management?</h5>
          <ul>
            <li>Professional and amateur athletes</li>
            <li>Children and adolescents involved in sports</li>
            <li>Adults starting new fitness programs</li>
            <li>Individuals with recurring sports-related pain</li>
          </ul>

          <p>
            Early sports injury management helps you recover faster, regain
            confidence, and return to your favorite activities with reduced risk
            of future injuries.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(SportsInjury);
